import { DataHeader, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTerminalCode extends Layout {
    dataheaderTerminalCode: DataHeader;
    sourceTerminalLookup: DataSource;
    textboxCounty: Textbox;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
